import * as React from 'react';
import JSZip from 'jszip';
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchMiddlePanelFilesData, resetMiddlePanelInitialState, resetMiddlePanel,toggleFileView,toggleSelectAll} from '../../../../containers/WorkkardDetail/actions/action';
import LoaderComponent from '../../../../components/Loader';
import {  FilesFilterConstants,VERIFICATION_TOKEN,MiddlePanelConstant } from "../../../../containers/WorkkardDetail/constants";
import FileGroup from './fileGroup';
import ListingComponent from "../../../../components/ListingComponent";
import WorkkardMultiOptionFilter from'../Filter/multiOptionFilter';
import Icons from "../../../../icons";
import { GetFileSizeRounded } from '../../../../containers/WorkkardDetail/utils';
import * as _ from 'lodash';
import CheckBox from '../../../../components/Checkbox';
import * as CommonUtil from '../../../../common/util';
import { hideToast } from '../../../SpockViewPage/actions/action';
import EmptyScreen from '../../../../Emptyscreen';
import { useLiveRefresh } from '../../../../utils/useLiveRefresh';

// `note` is included with `file`: note events carry attachments, so a new note
// can change what this panel should be showing.
//
// Scoped to the open claim: the user receives file and note events for every
// claim they act on, and this panel is only showing one of them.
const FILE_DOMAINS = ['file', 'note'];

class File extends React.Component{
    // filterOptions;
    constructor(props) {
        super(props);
        this.state = {
            filter: false,
            typeFilter:false,
            selectedFiles:[],
            TotalfileSize:0,
            isMultipleFileDownload:false,
            selectAll:false,
            closeFileDownloadAll:false,
            showDisplayType:false,
            filterOptions : Object.assign({}, FilesFilterConstants),
            isDeSelectAll:false,
            filesSelectOption:[],
            isZipDownloading:false,
        }
        this.renderFiles = this.renderFiles.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.onApplyFilter = this.onApplyFilter.bind(this);
        this.handleCheckboxChange=this.handleCheckboxChange.bind(this);
        this.downloadMultipleFiles=this.downloadMultipleFiles.bind(this);
        this.downloadSingleCellFile=this.downloadSingleCellFile.bind(this);
        this.downloadFilesAsZip=this.downloadFilesAsZip.bind(this);
        this.handleSelectAll=this.handleSelectAll.bind(this);
        this.handleCellFilesDownload=this.handleCellFilesDownload.bind(this);
        this.closeFileDownloadAll=this.closeFileDownloadAll.bind(this);
        
        this.handleOutSideClick = this.handleOutSideClick.bind(this);
        this.setInitialState = this.setInitialState.bind(this);
        // this.filterOptions = {...FilesFilterConstants};
        this.onTypeFilterApply=this.onTypeFilterApply.bind(this);
    }

    componentDidMount(){
        document.addEventListener('mousedown', this.handleOutSideClick)
        const { files } = this.props.middlePanel;
        const { workkard } = this.props;
        
        if (this.props && workkard) {
            let urlHash = this.props.history.location.hash;
            if (window.performance) {
                if (performance.navigation.type == 1) {
                    urlHash='#files';
                }
            }
            const fileType = urlHash === "#files" ? MiddlePanelConstant.All : (urlHash.charAt(2) === 'f' ? 
                (urlHash.charAt(1) === 'a' ? MiddlePanelConstant.ActivityType : MiddlePanelConstant.WorkkardType):
                files.type);
            this.onChangeType(fileType);
            
            const filterOption = this.props.middlePanel.files.filter.filterOption.slice();
            if(files.type == MiddlePanelConstant.All){
                filterOption.push('workkard','activity');
            }
            else{
                filterOption.push(files.type);
            }
            const payload = {
                type: fileType,
                cId: workkard.Id,
                actId: this.props.activityDetail.activityId || 0,
                skip: 0,
                take: 100,
                sortBy: "1",
                largeView:false,
                isSelectAll:false,
                filterOption: JSON.stringify(filterOption)
            }
            if ((fileType == MiddlePanelConstant.ActivityType && payload.actId > 0) || (fileType == MiddlePanelConstant.WorkkardType) || (fileType == MiddlePanelConstant.All )){
                this.props.fetchMiddlePanelFilesData(payload)
            }
        }
        this.setInitialState(files);
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps && newProps.activityDetail && newProps.activityDetail.activityId !== this.props.activityDetail.activityId
            ||
            (newProps.middlePanel.files.type !== this.props.middlePanel.files.type)
        ) {
            const { files } = newProps.middlePanel;
            const { workkard } = newProps;
            let updatedFilterOption = ["Document", "Photo", "Audio", "Video", "Email", "Other"];
            if(files.type == MiddlePanelConstant.All){
                updatedFilterOption.push('workkard','activity');
            }
            else{
                updatedFilterOption.push(files.type);
            }
            if(newProps.activityDetail.activityId !== this.props.activityDetail.activityId){
                const payload = {
                    type: 'files',
                    value: files.type,
                    filter: newProps.middlePanel.files.filter
                }
                this.props.resetMiddlePanel(payload)
            }

            this.setState({
                selectAll:false,
                isMultipleFileDownload:false,
                closeFileDownloadAll:false,
                selectedFiles:[],
                TotalfileSize:0,
            })

            const payload = {
                type: files.type,
                cId: workkard.Id,
                actId: newProps.activityDetail.activityId,
                skip: 0,
                take: 100,
                sortBy: "1",
                largeView:files.largeView,
                isSelectAll:files.isSelectAll,
                filterOption: JSON.stringify(updatedFilterOption),
                showToast:files.showToast
            }
            
            this.props.fetchMiddlePanelFilesData(payload)
            this.setState({filterOptions: Object.assign({}, FilesFilterConstants)})
        }
        
        if(newProps.middlePanel.files && newProps.middlePanel.files.type != this.props.middlePanel.files.type){
            this.setInitialState(newProps.middlePanel.files);
        }

        if(newProps.middlePanel.files && newProps.middlePanel.files.filter && newProps.middlePanel.files.filter.filterOption != this.props.middlePanel.files.filter.filterOption){
            this.setInitialState(newProps.middlePanel.files);
        }

        if(newProps.middlePanel && newProps.middlePanel.activeTab != this.props.middlePanel.activeTab && newProps.middlePanel.activeTab == '1'){
            this.setInitialState(newProps.middlePanel.files);
        }

        // if(newProps.middlePanel && newProps.middlePanel.files && newProps.middlePanel.files.type != this.props.middlePanel.files.type && newProps.middlePanel.files.filter.filterOption != this.props.middlePanel.files.filter.filterOption){
        //     this.setInitialState(newProps.middlePanel.files);
        // }
    }

    // The subscription itself lives in the wrapper below, because useLiveRefresh
    // is a hook; it reaches this class as a token that only changes when a
    // refresh is actually owed. Never fires on mount: the wrapper starts at 0.
    componentDidUpdate(prevProps) {
        if (prevProps.refreshToken !== this.props.refreshToken) {
            this.refreshFiles();
        }
    }

    refreshFiles() {
        const { files } = this.props.middlePanel;
        const { workkard, activityDetail } = this.props;
        if (!workkard || !workkard.Id) return;

        const actId = (activityDetail && activityDetail.activityId) || 0;
        if (files.type === MiddlePanelConstant.ActivityType && actId === 0) return;

        const filterOption = files.filter.filterOption.slice();
        if (files.type == MiddlePanelConstant.All) {
            filterOption.push('workkard', 'activity');
        } else {
            filterOption.push(files.type);
        }

        const loaded = parseInt(files.skip || 0, 10) + parseInt(files.take || 0, 10);
        this.props.fetchMiddlePanelFilesData({
            type: files.type,
            cId: workkard.Id,
            actId,
            skip: 0,
            take: Math.max(loaded, 100),
            sortBy: "1",
            largeView: files.largeView,
            isSelectAll: files.isSelectAll,
            filterOption: JSON.stringify(filterOption),
            silent: true,
        });
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleOutSideClick);
        this.props.hideToast();
    }

    SeturlHash(hash){
        let redirectPath = {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: `${hash}`
        }
        CommonUtil.redirectURL(this.props.history, redirectPath);
    }

    setInitialState(files){
        const {filterOption} = files.filter;
        const {type} = files;
        const filterOptions = {
            All: {
                name: 'ALL', value: '0', checked: false,
                options: [
                    {name: 'Document', value: 'Document', checked: filterOption.indexOf('Document') > -1},
                    {name: 'Photo', value: 'Photo', checked: filterOption.indexOf('Photo') > -1},
                    {name: 'Audio', value: 'Audio', checked: filterOption.indexOf('Audio') > -1},
                    {name: 'Video', value: 'Video', checked: filterOption.indexOf('Video') > -1},
                    {name: 'Email', value: 'Email', checked: filterOption.indexOf('Email') > -1},
                    {name: 'Other', value: 'Other', checked: filterOption.indexOf('Other') > -1},
                ]
            },
        };

        const filesSelectOption = {
            All: {
                name: '', value: '0', checked: type === "All" ? true : false,
                options: [
                    {name: 'Activity', value: 'activity', checked: ((type=='activity' || type === "All") ? true:false)},
                    {name: 'Workkard', value: 'workkard', checked: ((type=='workkard' || type === "All") ? true:false)},
                ]
            },
        };
        
        this.setState({
            filterOptions,
            filesSelectOption
        })

    }
    
    handleOutSideClick(e){
        if(this.menuRef && !this.menuRef.contains(e.target) && this.state.showDisplayType){
            this.setState({
                showDisplayType : false
            })
        }
    }

    onScrollHandler() {
        const { files } = this.props.middlePanel;
        const { skip, take} = files;
        const filterOption = files.filter.filterOption.slice();
        if(files.type == MiddlePanelConstant.All){
            filterOption.push('workkard','activity');
        }
        else{
            filterOption.push(files.type);
        }
        const payload = {
            type: files.type,
            cId: this.props.workkard.Id,
            actId: this.props.activityDetail.activityId,
            skip: (skip === 0 && take > 10 ) ? take : parseInt(skip)+parseInt(take),
            take : (skip === 0 && take > 10 ) ? 100 : parseInt(take),
            sortBy: "1",
            largeView:files.largeView,
            isSelectAll:files.isSelectAll,
            filterOption: JSON.stringify(filterOption)
        }

        if (skip + take < files.Total) {
            this.props.fetchMiddlePanelFilesData(payload);
        }
    }

    onChangeType(selectedValue){
        let hash = selectedValue === MiddlePanelConstant.All ? "files" : (selectedValue === MiddlePanelConstant.ActivityType ? 'af' : 'cf')
        this.SeturlHash(hash)

        const payload = {
            type: 'files',
            value: selectedValue,
            filter: this.props.middlePanel.files.filter
        }
        this.props.resetMiddlePanel(payload);
    }

    onTypeFilterApply(e){
        var filterOption = [],isToast=false;
        const keys = Object.keys(e);
        let type="All";
        let hash="files";
        {
            e[keys[0]].options
            .filter((optionData) => optionData.checked === true )
            .forEach((filteredValue ) => {
                filterOption = filterOption.concat(filteredValue.value);
            })
        }
        switch(true)
        {
            case (filterOption.includes("workkard") && filterOption.includes("activity")):
                hash="files";
                break;
            case (filterOption.includes("workkard")):
                type="workkard";               
                hash="cf";
                break;
            case (filterOption.includes("activity")):
                type="activity";               
                hash="af";
                break;
            default:
                isToast=true
        }

        if(!isToast)
            this.props.hideToast();

        this.SeturlHash(hash);
        const payload = {
            type: 'files',
            value: type,
            filter: this.props.middlePanel.files.filter,
            showToast : isToast
        }
        this.props.resetMiddlePanel(payload);
    }

    async onApplyFilter(e){
        const { files } = this.props.middlePanel;
        const { workkard } = this.props;
        var filterOption = [];
        const keys = Object.keys(e);
        {
            e[keys[0]].options
            .filter((optionData) => optionData.checked === true )
            .forEach((filteredValue ) => {
                filterOption = filterOption.concat(filteredValue.value);
            })
        }

        if(filterOption.length==0)
        {
            this.state.filterOptions.All.options.map((item,key)=>{
                filterOption.push(item.value)
            })
        }
        
        const appliedFilter = filterOption.slice();
        if(files.type == MiddlePanelConstant.All){
            filterOption.push('workkard','activity');
        }
        else{
            filterOption.push(files.type);
        }
        
        let urlHash = this.props.history.location.hash;
            
        const fileType = urlHash === "#files" ? MiddlePanelConstant.All : (urlHash.charAt(2) === 'f' ? 
            (urlHash.charAt(1) === 'a' ? MiddlePanelConstant.ActivityType : MiddlePanelConstant.WorkkardType):
            files.type);
        const payload = {
            type: fileType,
            cId: workkard.Id,
            actId: this.props.activityDetail.activityId,
            skip: 0,
            take: 100,
            sortBy: "1",
            largeView:files.largeView,
            isSelectAll:files.isSelectAll,
            filterOption: JSON.stringify(filterOption)
        }
        const payloadtype = {
            type: 'files',
            value: fileType,
            filter: {filterOption: appliedFilter},
        }
        await this.props.resetMiddlePanel(payloadtype);
        await this.props.fetchMiddlePanelFilesData(payload);
        this.setState({
            selectedFiles: [],
            selectAll:false
        })
        this.props.toggleSelectAll(false);
    }

    renderFiles(files){
        if (files && files.length > 0) {

            const noteIds = files.map(item=>{
                const date = item.UploadedDateString.split('at');
                return {id:item.Id, date:date[0], time:date[1], data: item}
            });
            const groupNoteIds = _.groupBy(noteIds, 'date');

            const prop = {
              data:Object.keys(groupNoteIds).map(key=>({key,data:groupNoteIds[key]})),
              cellTemplate: FileGroup,
              onScrollHandler: this.onScrollHandler,
              onItemClick: (isChecked,file) =>this.handleCheckboxChange(isChecked,file),
              onCellClick:(isCellDownload,data)=> this.handleCellFilesDownload(isCellDownload,data),
              type:"div",
              selectedId: '',
              classname:'scrollArea',
              extraData:{isDeselectAll:this.state.isDeSelectAll, selectedFiles: this.state.selectedFiles}
            }

            return (
              <ListingComponent {...prop}/>
            );
        }
        return !(this.props.isLoading || this.props.isMiddlePanelLoading) && <EmptyScreen name="Emptyfiles" type={this.props.middlePanel.files.type == "All" ? "activity & workkard" : this.props.middlePanel.files.type} />;
    }

    handleCellFilesDownload(isCellDownload,data){
        if(isCellDownload){
            if(data.length === 1){
                this.downloadSingleCellFile(data[0]);
                return;
            }
            this.downloadFilesAsZip(data, `${this.props.workkard.WorkkardNumber}.zip`);
        }
    }

    async downloadSingleCellFile(file){
        try{
            await CommonUtil.downloadFile(file.FileGuid, file.FileName);
        } catch(e){
            console.log(e);
        }
    }

    async downloadFilesAsZip(files, zipName){
        if(files.length === 1){
            await this.downloadSingleCellFile(files[0]);
            return;
        }
        this.setState({isZipDownloading:true});
        try{
            const zip = new JSZip();
            await Promise.all(files.map(async (file) => {
                const response = await CommonUtil.fetchDownload(file.FileGuid);
                zip.file(file.FileName, response.data);
            }));
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            CommonUtil.triggerBlobDownload(zipBlob, zipName);
        } catch(e){
            console.log(e);
        } finally {
            this.setState({isZipDownloading:false});
        }
    }

    calculateTotalFileSize(){
        let TotalfileSize = [...this.state.selectedFiles].reduce((initial, obj)=> { return +initial + +obj.OriginalFileSize; }, 0);
        this.setState({
            TotalfileSize : GetFileSizeRounded(TotalfileSize)
        })
    }

    handleCheckboxChange(isChecked,file){
        if(isChecked){
            this.setState({
                closeFileDownloadAll:false
            })
            this.setState(prevState=>{
                return {selectedFiles : this.state.selectAll ? [...prevState.selectedFiles]:[...prevState.selectedFiles,file]}
            },()=>{
                this.calculateTotalFileSize();    
                if(this.state.selectedFiles.length==this.props.middlePanel.files.Total){
                    this.setState({
                        selectAll:true
                    })
                    this.props.toggleSelectAll(true)
                }           
            })
            return;
        }
        this.setState(prevState=>{
            return {selectedFiles:prevState.selectedFiles.filter(item=>(item.FileGuid!=file.FileGuid))}
        },()=>{
            this.calculateTotalFileSize();
            if(this.state.selectedFiles.length ==0){
                this.setState({
                    isDeSelectAll:true,
                    selectAll:false
                })
                this.props.toggleSelectAll(false)
            }
            if (this.state.selectedFiles.length < this.props.middlePanel.files.Total) {
                this.setState({
                    selectAll: false
                })
                this.props.toggleSelectAll(false)
            }

        })
    }

    handleSelectAll(){
       return  this.setState({
            selectAll: !this.state.selectAll
        },()=>{
            if (this.state.selectAll) {
                this.setState({
                    selectedFiles: [].concat.apply([], this.props.middlePanel.files.Data.map(data => data).map(item => item.Files))
                },()=>{
                    this.calculateTotalFileSize()})
            } else {
                this.setState({ selectedFiles: [] })
            }
            this.props.toggleSelectAll(this.state.selectAll)
        })
    }


    async downloadMultipleFiles (){
        const selectedFiles=[...this.state.selectedFiles];
        await this.downloadFilesAsZip(selectedFiles, `${this.props.workkard.WorkkardNumber}.zip`);
        this.setState({isMultipleFileDownload:false});
        if(this.state.selectAll){
            this.handleSelectAll()
        }
        else if(!this.state.isDeSelectAll){
            this.setState({isDeSelectAll:true,selectedFiles:[]})
        }
    }
    closeFileDownloadAll(){
        this.setState({
            closeFileDownloadAll:true
        })
    }

    render(){
        const { files } = this.props.middlePanel;
        const { isLoading,isMiddlePanelLoading } = this.props;
        const selectOptions = [
            {
                label: "Activity files",
                value: "activity"
            },
            {
                label: "Workkard files",
                value: "workkard"
            }
        ]
        return (
            <div>
                {(isLoading || isMiddlePanelLoading || this.state.isZipDownloading) &&
                    <LoaderComponent />
                }
                <div className="filterBlock rowFlex">
                    <div className="filterLeft" data-test={`filters`}>
                        <div className="dropDown alignMiddle pd__none">
                            <a className="alignMiddle black" href="javascript:void(0)" onClick={() => this.setState({filter : !this.state.filter})}><Icons name="filter" className="icon mr"/> Filters</a>
                            {this.state.filter && <WorkkardMultiOptionFilter filterOptions = {this.state.filterOptions} onCheckChange = {this.onApplyFilter} onClose={() => this.setState({filter :false})} showHeader={true} showParentOption={false}/>}
                        </div>
                    </div>
                    <div className="filterRight alignMiddle" data-test={`fileType ${files.type}`}>
                        {
                            files && files.Data.length==0 ?
                            null:
                            <div className="flexGrow selectAll">
                                <CheckBox item={{id:"selectAll", checked:this.state.selectAll,label:"Select All"}} handleCheckbox={this.handleSelectAll} />
                            </div>
                        }

                        <div className="dropDown medium alignMiddle pd__none ml__1 mr__1">
                            <label className="mr">Files</label>
                            <a className="alignMiddle black" href="javascript:void(0)" onClick={() => this.setState({typeFilter : !this.state.typeFilter})}>
                                <span className="dropDownActive">
                                    {files.type === "All" ? ("Activity & Workkard") : files.type.charAt(0).toUpperCase()+ files.type.slice(1) }
                                    <Icons name="downArrow" className="icon ml" />
                                </span>
                            </a>
                            {this.state.typeFilter && <WorkkardMultiOptionFilter filterOptions = {this.state.filesSelectOption} onCheckChange = {this.onTypeFilterApply} onClose={() => this.setState({typeFilter :false})} showHeader={false} showParentOption={false}  openRight={true}/>}
                        </div>

                        {/* <div className="formGroup mr ml">
                            <select className="ml" onChange={(e) => this.onChangeType(e.target.value)}>
                                <option value="activity" selected={this.props.history.location.hash.charAt(1) === 'a' ? true: undefined}>Activity files</option>
                                <option value="workkard" selected={this.props.history.location.hash.charAt(1) === 'c' ? true: undefined}>Workkard files</option>
                            </select>
                        </div> */}
                        <div className="dropDown" ref={(node) => {this.menuRef = node}}>
                            <a className="alignMiddle" href="javascript:void(0)" onClick={() => this.setState({showDisplayType : !this.state.showDisplayType})}>
                                {this.props.isLargeView ?<Icons name="largeview" className="icon"/> : <Icons name="thumbview" className="icon"/>}
                            </a>
                            { this.state.showDisplayType && <div className="dropDownMenu small openRight onClick" ref={(node) => {this.menuRef = node}}>
                                    <div className="rowFlex toggleFileView rowSpaceBetween">
                                        <a href="javascript:void(0)" onClick={()=>{
                                                this.setState({showDisplayType: false});
                                                this.props.toggleFileView(false)
                                            }}>
                                            <Icons name="thumbview" className={this.props.isLargeView ? "thumbView":"thumbView active"}/>
                                        </a>
                                        <a href="javascript:void(0)" onClick={()=>{
                                                this.setState({showDisplayType: false});
                                                this.props.toggleFileView(true)
                                            }}>
                                            <Icons name="largeview" className={this.props.isLargeView ? "largeView active":"largeView"}/>
                                        </a>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className={files && files.Data.length<1 ?  "filesMainContainer detailMainContainer noDataFound": "filesMainContainer detailMainContainer"}>
                    {
                        (
                            files
                            &&
                            files.Data
                            &&
                            this.renderFiles(files.Data)
                        )
                    }
                    {
                        this.state.closeFileDownloadAll ?
                        null
                        :
                        this.state.selectedFiles.length!=0 &&
                        
                            <div className="fileDownloadAll toast toastTop rowFlex rowSpaceBetween alignMiddle animated faster fadeInDown">
                                
                                {
                                    (this.state.selectedFiles.length!=0)?
                                    <label className="mr__1">{this.state.selectedFiles.length} selected ({this.state.TotalfileSize})</label>
                                    :
                                    null
                                }
                                <a href="javascript:void(0)" className="downloadLink linkWhite" onClick={()=>{this.setState({isMultipleFileDownload:true},this.downloadMultipleFiles)}}><Icons name="download" className="icon mr"/> Download</a>
                                {/* {  (this.state.selectedFiles.length==0)? <Icons name="closeFilled" className="icon ml__1" onClick={this.closeFileDownloadAll}/>:null} */}
                            </div>
                        
                    }
                </div>
            </div>
        );
    }
}

const CustomErrorComponent = () => {
    return(
        <h1> error component will be there </h1>
    );
}

const mapStateToProps = (state) => ({
    activityDetail: state.workkardDetail.activityDetail,
    workkard: state.workkardDetail.workkardDetail,
    middlePanel : state.workkardDetail.middlePanel,
    isMiddlePanelLoading: state.workkardDetail.middlePanel.isLoading,
    isLoading:state.isLoading,
    isLargeView:state.workkardDetail.middlePanel.files.largeView,
});

const mapDispatchToProps = (dispatch) => ({
    fetchMiddlePanelFilesData: bindActionCreators(fetchMiddlePanelFilesData, dispatch),
    resetMiddlePanel: bindActionCreators(resetMiddlePanel, dispatch),
    resetMiddlePanelInitialState: bindActionCreators(resetMiddlePanelInitialState, dispatch),
    toggleFileView:bindActionCreators(toggleFileView,dispatch),
    toggleSelectAll:bindActionCreators(toggleSelectAll,dispatch),
    hideToast:bindActionCreators(hideToast,dispatch),
});

const ConnectedFile = connect(
    mapStateToProps,
    mapDispatchToProps
)(File);

// useLiveRefresh cannot be called from a class component, so the subscription --
// with the burst coalescing and the background-tab gate it carries -- lives here
// and reaches the class as a plain counter prop it can compare.
const FileWithLiveRefresh = (props) => {
    const workkardId = useSelector((state) => state.workkardDetail?.workkardDetail?.Id);
    const [refreshToken, setRefreshToken] = React.useState(0);
    useLiveRefresh(FILE_DOMAINS, () => setRefreshToken((token) => token + 1), { workkardId });
    return <ConnectedFile {...props} refreshToken={refreshToken} />;
};

export default FileWithLiveRefresh;